/**
 * DISTRIBUTION-MAP MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// ISO-3166-2:US codes for all 50 states + DC. The region_code column on
// map_regions stores values from this set. This is the canonical allowlist —
// anything coming back from the API is validated against it before we let it
// drive UI or a SVG path lookup.

export const US_STATES = [
  ["US-AL", "Alabama"],        ["US-AK", "Alaska"],         ["US-AZ", "Arizona"],
  ["US-AR", "Arkansas"],       ["US-CA", "California"],     ["US-CO", "Colorado"],
  ["US-CT", "Connecticut"],    ["US-DE", "Delaware"],       ["US-DC", "District of Columbia"],
  ["US-FL", "Florida"],        ["US-GA", "Georgia"],        ["US-HI", "Hawaii"],
  ["US-ID", "Idaho"],          ["US-IL", "Illinois"],       ["US-IN", "Indiana"],
  ["US-IA", "Iowa"],           ["US-KS", "Kansas"],         ["US-KY", "Kentucky"],
  ["US-LA", "Louisiana"],      ["US-ME", "Maine"],          ["US-MD", "Maryland"],
  ["US-MA", "Massachusetts"],  ["US-MI", "Michigan"],       ["US-MN", "Minnesota"],
  ["US-MS", "Mississippi"],    ["US-MO", "Missouri"],       ["US-MT", "Montana"],
  ["US-NE", "Nebraska"],       ["US-NV", "Nevada"],         ["US-NH", "New Hampshire"],
  ["US-NJ", "New Jersey"],     ["US-NM", "New Mexico"],     ["US-NY", "New York"],
  ["US-NC", "North Carolina"], ["US-ND", "North Dakota"],   ["US-OH", "Ohio"],
  ["US-OK", "Oklahoma"],       ["US-OR", "Oregon"],         ["US-PA", "Pennsylvania"],
  ["US-RI", "Rhode Island"],   ["US-SC", "South Carolina"], ["US-SD", "South Dakota"],
  ["US-TN", "Tennessee"],      ["US-TX", "Texas"],          ["US-UT", "Utah"],
  ["US-VT", "Vermont"],        ["US-VA", "Virginia"],       ["US-WA", "Washington"],
  ["US-WV", "West Virginia"],  ["US-WI", "Wisconsin"],      ["US-WY", "Wyoming"],
];

export const US_STATE_CODES = US_STATES.map(([code]) => code);
export const US_STATE_NAME  = Object.fromEntries(US_STATES);

// Reverse lookups for matching System Settings free-text state names to the
// ISO codes the renderer keys on. Both full name and 2-letter abbreviation.
const NAME_TO_CODE = Object.fromEntries(US_STATES.map(([code, name]) => [name.toLowerCase(), code]));
const ABBR_TO_CODE = Object.fromEntries(US_STATES.map(([code]) => [code.slice(3).toLowerCase(), code]));
const CODE_SET = new Set(US_STATE_CODES);

/**
 * Resolve a System Settings state value to an ISO code ("US-CA"), or null if it
 * can't be matched. Accepts a full name ("California"), a 2-letter abbreviation
 * ("CA"), or an already-ISO code ("US-CA"). Case/space tolerant.
 */
export function nameToStateCode(value) {
  if (!value) return null;
  const v = String(value).trim();
  if (CODE_SET.has(v.toUpperCase())) return v.toUpperCase();
  const lower = v.toLowerCase();
  if (NAME_TO_CODE[lower]) return NAME_TO_CODE[lower];
  if (ABBR_TO_CODE[lower]) return ABBR_TO_CODE[lower];
  return null;
}

// Colorblind-safe qualitative palette (Okabe–Ito). Used to auto-assign a
// distinct default color per distributor before the user customizes one.
export const DEFAULT_PALETTE = [
  "#0072b2", "#e69f00", "#009e73", "#cc79a7",
  "#56b4e9", "#d55e00", "#f0e442", "#999999",
];

export function defaultColorFor(index) {
  return DEFAULT_PALETTE[((index % DEFAULT_PALETTE.length) + DEFAULT_PALETTE.length) % DEFAULT_PALETTE.length];
}
